import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldText, FormField } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { Field } from 'redux-form';
import { FieldTemplate } from 'components/fieldTemplate';
import { CARD_V2 } from 'components/shared/util/customCard';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { editorMaxLines, templateHelpText } from '../cards.utils';
import { CardsFormWrapper } from '../components/formWrapper';
import shopifyTemplate from './fixtures/shopifyTemplate.liquid.html';
import { apiKeyHelpText, apiPasswordHelpText, subdomainHelpText, } from './shopifyCards.utils';
export function ShopifyCards({ mode }) {
    const { organizationId } = useAppSelector(({ settings }) => {
        return { organizationId: settings.organization.organization.id };
    });
    const shopifyCardType = 'shopify';
    const templateURL = useCallback((formValues) => `http://proxy.dixa/v1/proxy/${organizationId}/${shopifyCardType}?api_key=${formValues.hook.api_key}&password=${formValues.hook.password}&api_hostname=${formValues.hook.shopifySubdomain}&a_email={{a_email}}&a_phone_number={{a_phone_number}}`, [organizationId]);
    const getEditObject = useCallback((formValues) => ({
        card_type: shopifyCardType,
        hook: {
            hook_id: formValues.hook.hook_id,
            title: formValues.hook.title,
            uri_template: templateURL(formValues),
            headers: {},
            card_version: formValues.hook.card_version,
        },
        template: formValues.template,
    }), [templateURL]);
    const getCreateObject = useCallback((formValues) => ({
        card_type: shopifyCardType,
        hook: {
            title: formValues.hook.title,
            uri_template: templateURL(formValues),
            headers: {},
            // All new Cards are forced to use V2
            card_version: CARD_V2,
        },
        template: formValues.template,
    }), [templateURL]);
    return (_jsx(CardsFormWrapper, Object.assign({ isDeprecated: true, form: "shopifyCardsForm", mode: mode, cardType: shopifyCardType, getEditObject: getEditObject, getCreateObject: getCreateObject, template: shopifyTemplate }, { children: _jsxs(_Fragment, { children: [_jsx(FormField, Object.assign({ span: 3 }, { children: _jsx(Field, { required: true, label: "Title", name: "hook.title", component: FieldText, placeholder: "Insert title" }) })), _jsx(FormField, { span: 3 }), _jsx(FormField, Object.assign({ span: 3 }, { children: _jsx(Field, { required: true, label: "API key", name: "hook.api_key", component: FieldText, placeholder: "Insert API key", helpIcon: {
                            title: 'API key help',
                            text: apiKeyHelpText,
                        } }) })), _jsx(FormField, { span: 3 }), _jsx(FormField, Object.assign({ span: 3 }, { children: _jsx(Field, { required: true, label: "API password", name: "hook.password", component: FieldText, placeholder: "Insert API password", helpIcon: {
                            title: 'API password help',
                            text: apiPasswordHelpText,
                        } }) })), _jsx(FormField, { span: 3 }), _jsx(FormField, Object.assign({ span: 3 }, { children: _jsx(Field, { required: true, label: "Subdomain", name: "hook.shopifySubdomain", component: FieldText, placeholder: "Insert subdomain", helpIcon: {
                            title: 'Subdomain help',
                            text: subdomainHelpText,
                        }, prefix: 'https://' }) })), _jsx(FormField, { span: 3 }), _jsx(FormField, { children: _jsx(Field, { required: true, defaultHidden: true, label: "Template content", name: "template", component: FieldTemplate, helpIcon: {
                            title: 'Template help',
                            text: templateHelpText,
                            requireClick: true,
                        }, editorOptions: { maxLines: editorMaxLines }, placeholder: "Insert template" }) })] }) })));
}
